import _ from "lodash";
export default {
  state: {
    versions: [],
    selectedVersion: [],
    trainingStatus: false,
  },
  getters: {
    "nlp/versions/query": (state) => (query) => {
      const fallback = [];
      if (!state.versions || !state.versions.length) return fallback;
      const result = state.versions.filter((version) =>
        version.name.toLowerCase().includes(query.toLowerCase())
      );
      return result && result.length ? result.reverse() : fallback;
    },
  },
  mutations: {
    "nlp/versions/add": function (state, data) {
      state.versions.splice(0, 0, data);
    },
    "nlp/versions/set": function (state, data) {
      state.versions = data;
    },
    "nlp/version/select": function (state, data) {
      state.selectedApp = data;
    },
    "nlp/versions/train/status/set": function (state, data) {
      state.trainingStatus = data;
    },
  },
  actions: {
    "nlp/versions/get": async function (
      { commit, dispatch, state },
      payload = null
    ) {
      try {
        const app = payload ? payload : state.selectedApp.id;
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_nlp.get(`/apps/${app}/versions`);
        dispatch("nlp/versions/train/status/get");
        dispatch("setLoader", false);
        const { result } = data.data;
        commit("nlp/versions/set", result);
        return result;
      } catch (err) {
        commit("nlp/versions/set", []);
        throw err;
      }
    },
    "nlp/versions/add": async function ({ dispatch, state }, payload) {
      try {
        const pack = payload;
        if (!payload.app) {
          pack.app = state.selectedApp.id;
        }
        const { data } = await this._vm.$http_nlp.post(
          `/apps/${state.selectedApp.id}/versions`,
          pack
        );
        dispatch("nlp/versions/get");
        return data;
      } catch (err) {
        throw err;
      }
    },
    "nlp/versions/clone": async function ({ state }, id) {
      try {
        await this._vm.$http_nlp.post(
          `/apps/${state.selectedApp.id}/versions/${id}/clone`
        );
        return true;
      } catch (err) {
        throw err;
      }
    },
    "nlp/versions/train": async function ({ dispatch, state }) {
      try {
        dispatch("setLoader", true);
        await this._vm.$http_nlp.post(
          `/apps/${state.selectedApp.id}/versions/${
            state.versions.filter((v) => v.status === "ACTIVE")[0].id
          }/train`
        );
        dispatch("setLoader", false);
        dispatch("nlp/versions/train/status/get");
        return true;
      } catch (err) {
        throw err;
      }
    },
    "nlp/versions/train/status/get": async function ({
      dispatch,
      commit,
      state,
    }) {
      try {
        // check the active version
        const activeVersionFilter = state.versions.filter(
          (v) => v.status === "ACTIVE"
        );
        const activeVersion = activeVersionFilter.length
          ? activeVersionFilter[0]
          : null;
        if (!activeVersion) {
          commit("nlp/versions/train/status/set", false);
          return false;
        }

        // dispatch('setLoader', true)
        const { data } = await this._vm.$http_nlp.get(
          `/apps/${state.selectedApp.id}/versions/${activeVersion.id}/training-status`
        );
        if (data.data && data.data.status === "InProgress") {
          commit("nlp/versions/train/status/set", true);
          setTimeout(() => {
            dispatch("nlp/versions/train/status/get");
          }, 5000);
        } else if (data.data && data.data.status === "Success") {
          commit("nlp/versions/train/status/set", false);
          return false;
        }
        // dispatch('setLoader', false)
      } catch (err) {
        throw err;
      }
    },
    "nlp/versions/update": async function ({ dispatch, state }, payload) {
      try {
        const { data } = await this._vm.$http_nlp.put(
          `/apps/${state.selectedApp.id}/versions/${payload.id}`,
          { name: payload.name, ..._.omit(payload, "id") }
        );
        dispatch("nlp/versions/get");
        return data;
      } catch (err) {
        throw err;
      }
    },
    "nlp/versions/delete": async function ({ state }, id) {
      try {
        await this._vm.$http_nlp.delete(
          `/apps/${state.selectedApp.id}/versions/${id}`
        );
        return true;
      } catch (err) {
        throw err;
      }
    },
    "nlp/versions/delete/single": async function ({ dispatch, state }, id) {
      try {
        await this._vm.$http_nlp.delete(
          `/apps/${state.selectedApp.id}/versions/${id}`
        );
        dispatch("nlp/versions/get");
        return true;
      } catch (err) {
        throw err;
      }
    },
    "nlp/versions/activate": async function ({ dispatch, state }, id) {
      try {
        await this._vm.$http_nlp.put(
          `/apps/${state.selectedApp.id}/versions/${id}/activate`
        );
        dispatch("nlp/versions/get");
        return true;
      } catch (err) {
        throw err;
      }
    },
    "nlp/versions/delete/multiple": async function ({ dispatch }, payload) {
      try {
        dispatch("setLoader", true);
        let i;
        for (i = 0; i < payload.length; i += 1) {
          try {
            await dispatch("nlp/versions/delete", payload[i].id);
          } catch (err) {
            throw err;
          }
          if (i === payload.length - 1) return dispatch("nlp/versions/get");
        }
      } catch (err) {
        throw new Error(err);
      }
    },
    "nlp/versions/set": function ({ commit }, data) {
      commit("nlp/versions/set", data);
      return data;
    },
  },
};
